module.exports = __webpack_public_path__ + "static/media/sampleCohortOverview.02e26209.PNG";